import declare from "dojo/_base/declare";
import MultiSelectSwitchboard from "csi/toolbar/MultiSelectSwitchboard";

const CareInstructionsAndIconsPSRSwitchboard = declare(MultiSelectSwitchboard, {

	idViewProperty: "activeProductSalesRegions",
	switchboardPath: "Child:__Parent__/Child:__Parent__/Child:ProductSalesRegions",
});
export = CareInstructionsAndIconsPSRSwitchboard;